import { render, staticRenderFns } from "./CardEvaluacion.vue?vue&type=template&id=5f819c92&scoped=true"
import script from "./CardEvaluacion.vue?vue&type=script&lang=js"
export * from "./CardEvaluacion.vue?vue&type=script&lang=js"
import style0 from "./CardEvaluacion.vue?vue&type=style&index=0&id=5f819c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f819c92",
  null
  
)

export default component.exports